<ion-button (click)="login()">
    {{ 'Login' | translate }}
</ion-button>